export default "__VITE_ASSET__bc878a21__"